import { API_BASE_URL } from "@kupikupi/brand";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type SubmitOrderInput, submitOrder } from "../endpoints/order";

const ctx = { baseUrl: API_BASE_URL };

/**
 * Submits the picked cart lines as a FORMAL order via POST /order/submitV2 and
 * resolves to the real `orderNo` the cashier needs. On success the cart and
 * pre-order caches are invalidated (the lines have left the cart). The caller
 * does the `/pay?orderNo=…` navigation so loading/error stay co-located with
 * the button (#260).
 */
export function useSubmitOrder(authToken: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: SubmitOrderInput) => {
      if (!authToken) throw new Error("NO_TOKEN");
      return submitOrder(ctx, authToken, input);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["cart"] });
      void qc.invalidateQueries({ queryKey: ["preorder"] });
    },
  });
}
